import React from "react";
import borderBuyers from "../../../assets/images/icons/buyers/border-buyers.svg"
import defaultIcon from "../../../assets/images/icons/buyers/image-buyers.svg"

const BuyerCard = ({
  name,
  position,
  email,
  borderImage = borderBuyers,
  iconImage,
  showEmail = true,
  height="h-[400px]",
  showPhone = true,
  pt = true,
  phoneNumber, 
  visibility_email = true,
  visibility_contact_number = true,
  areaName
}) => {

  const isManagerOrSubManager = () => {
    if (!position) return false;
    const lowerPosition = position.toLowerCase();
    return (
      lowerPosition.includes("gerente") || 
      lowerPosition.includes("subgerente")
    );
  };

  const handleWhatsAppClick = (phoneNumber) => {
    if (!phoneNumber) return;
    
    const cleanedNumber = phoneNumber.toString().replace(/\D/g, '');
    
    if (cleanedNumber.length < 9) {
      console.error('Número de teléfono inválido');
      return;
    }

    const formattedNumber = cleanedNumber.startsWith('51') 
      ? cleanedNumber 
      : `51${cleanedNumber}`;

    const whatsappUrl = `https://wa.me/${formattedNumber}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className={`flex flex-col  items-center justify-start gap-1 p-2 px-[20px] text-center
     ${height}
     ${pt ? 'pt-10' : 'pt-3'}`}>
      <div className="relative">
        <img src={borderImage} alt="Borde" className="w-[101px] h-[101px]" />
        <div className="absolute inset-0 flex items-center justify-center">
           <img 
            src={iconImage || defaultIcon} 
            alt="icon" 
            className="w-[80px] rounded-full h-[80px] object-cover" 
          />
        </div>
      </div>
      <p className="text-[#184A7D] font-itcdemi text-[18px]">{name}</p>
      <p className="text-[#184A7D] font-itcbook text-[16px]">{position}</p>
      {showPhone && phoneNumber && visibility_contact_number && !isManagerOrSubManager() && (
        <button 
          onClick={() => handleWhatsAppClick(phoneNumber)}
          className="text-[#58B6E5] font-itcmedium text-[13px] hover:underline cursor-pointer"
          title="Haga clic para contactar por WhatsApp"
        >
          {phoneNumber}
        </button>
      )}
      {showEmail && email && visibility_email && !isManagerOrSubManager() && (
        <a 
        href={`mailto:${email}`} 
        className="font-itcbook text-[16px] underline text-center break-words w-full"
        style={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',

        }}
        title={email}
      >{email}
        </a>
      )}
      {areaName && (
        <p className={`font-itcmedium text-[13px] break-words text-[#769B40]`}>
          {areaName}</p>
      )}


    </div>
  );
};

export default BuyerCard;